import dayjs from 'dayjs';
import { useCookies } from 'react-cookie';
import { useRecoilValueLoadable, useSetRecoilState } from 'recoil';
import { CustomerType } from 'api';
import getCustomerAtom, { customerRequestIdState } from 'api/customers/getCustomer';
import getCustomerHasArchivedPassings from 'api/passings/getCustomerHasArchivedPassings';
import { USER_COOKIE_NAME } from 'constants/cookies';
import userAtom from 'state/user';
import checkLoadable from 'utils/recoil/checkLoadable';
export default function useCurrentCustomer() {
  const [cookies, setCookie, removeCookie] = useCookies([USER_COOKIE_NAME]);
  const userCookie = cookies[USER_COOKIE_NAME];
  const setCustomerRequestId = useSetRecoilState(customerRequestIdState);
  const customerLoadable = useRecoilValueLoadable(getCustomerAtom(userCookie));
  const {
    contents: customer,
    loading,
    error
  } = checkLoadable(customerLoadable);
  const hasArchivedPassingsLoadable = useRecoilValueLoadable(getCustomerHasArchivedPassings(userCookie));
  const {
    contents: hasArchivedPassings
  } = checkLoadable(hasArchivedPassingsLoadable);
  const isBusinessCustomer = customer?.customerType === CustomerType.Company;
  const setCustomerAtom = useSetRecoilState(userAtom);
  const setCustomer = customerObject => {
    setCookie(USER_COOKIE_NAME, customerObject.id, {
      expires: dayjs().add(4, 'hour').toDate()
    });
    setCustomerAtom(customerObject);
    setCustomerRequestId(prev => prev + 1);
  };
  const resetCustomer = () => {
    removeCookie(USER_COOKIE_NAME);
  };
  return {
    customer,
    setCustomer,
    resetCustomer,
    loading,
    error,
    isBusinessCustomer,
    hasArchivedPassings
  };
}